import { useEffect, useRef, useState } from 'react';
import "./ChatAI.scss"
import QuickQuery from '../Copilot/QuickQuery';
import Conversation from './Conversation';
import useAuth from '../../hooks/useAuth';
import { MessageData } from '../../types/chat-bot-hub/MessageData';
import { quickQueryCards } from '../../types/chat-bot-hub/QuickQueryCards';

interface NewChatProps {
  messages: MessageData[];
  sendTextToChatBot: (sessionId: string,isCancellationRequest: boolean, msg : string) => void;
  responseCompleted: boolean;
  quickQueryCards: quickQueryCards[];
}
const ChatAI : React.FC<NewChatProps> = ({messages,sendTextToChatBot,responseCompleted,quickQueryCards}) => {
    const [showConversation, setShowConversation] = useState(false);
    const [localInputText, setLocalInputText] = useState<string>("");
    const [localIsProcessing,setLocalIsProcessing]= useState(false);
    const auth = useAuth();
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        if (responseCompleted) {
          setLocalIsProcessing(false);
        }
      }, [responseCompleted]);

    const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalInputText(event.target.value); 
    }
     const handleQuickQuerySelect = (queryText: string) => {
      setLocalInputText(queryText);
    };
     const handleClick = () => {
      sendTextToChatBot("", localIsProcessing,localInputText);  
      
      setLocalIsProcessing(!localIsProcessing);
      setShowConversation(true);   
      setLocalInputText('');   
    };
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === "Enter") {
              event.preventDefault(); 
              handleClick(); 
            }
          };

    return (
        <div>
            {showConversation ?<div className="chatwindow h-100">
              <Conversation messages={messages}  sendTextToChatBot={sendTextToChatBot} responseCompleted={responseCompleted}/>
            </div> :
             <div className="callListInner h-100 pb-3">
            <div className="chat-window">
                <div className="row">
                <div className="col-md-12">
                <div className="welcomepanel d-flex justify-content-center text-center">
                  <div className="welcomelabel">
                    <h1 className="welcomeTitle"><i className="bi bi-stars text-primary mr-2"></i>Welcome {auth?.user?.firstName}, How can I help?</h1>
                  </div>
                </div>
                <div className="typingchat">
                <div className="chatsection">
                  <form action="#" className="">
      <div ref={wrapperRef} className="container mt-4 relative">
        <div className="d-flex align-items-center rounded-pill shadowsm typingarea bg-white">
          <input
            type="text"
            value={localInputText}
            className="form-control border-0 shadow-none ms-2 bg-transparent"
            placeholder="Ask anything....."
            disabled = {localIsProcessing}
            onChange={handleInput}
             onKeyDown={handleKeyDown}
          />
          <button
            type="button"
            className="btn rounded-circle d-flex align-items-center justify-content-center me-1 chatbtn"
            onClick={handleClick}
            disabled= {localIsProcessing}
          >
            {/* {!localIsProcessing ?<i className="bi bi-arrow-up text-white"></i> :
            <i className="bi bi-stop-circle text-white"></i>} */}
            <i className="bi bi-arrow-up text-white"></i>
          </button>
        </div>
      </div>
    </form>

                    {/* {messages.map((m, i) => {
                        return (
                            <>
                            {m.TextRequest && m.TextRequest !== "" &&
                                <div key={i} className="message user">
                                    {!m.IsCancelled && !m.IsErrored && !m.IsCompleted &&
                                        <div className="cursor-pointer m-r-5 m-t-10" onClick={() => sendTextToChatBot(m.RequestId, true)}>
                                            <i className="bi bi-stop-circle fs-20"></i>
                                        </div>
                                    }
                                     <div className="message-text">
                                      <Conversation/>
                                     </div>
                                     <div className="message-text">{m.TextRequest}</div> 
                                    <div className="m-t-10">
                                        {!m.IsCancelled && !m.IsErrored && !m.IsCompleted && <Loader className="m-l-5" themeColor={"primary"} size={"small"} type={"infinite-spinner"}/>}
                                        {m.IsCancelled && <i className="m-l-5 bi bi-pause-circle fs-20"></i>}
                                        {m.IsErrored && <i className="m-l-5 bi bi-x-circle fs-20"></i>}
                                        {m.IsCompleted && <i className="m-l-5 bi bi-check-circle fs-20"></i>}
                                    </div>
                                </div>
                            }
                            {m.TextResult.map((tr, j) =>{
                                return (
                                    <>
                                    {tr && tr !== "" &&
                                        <div key={j} className="message bot">
                                            <div className="message-text">{tr}</div>
                                        </div>
                                    }
                                    </>
                                )
                            })}
                            </>
                            
                        )
                    })} */}
                </div>
               <div className="container mt-4 suggest-section">
                    <QuickQuery onQuerySelect={handleQuickQuerySelect} quickQueryCards={quickQueryCards}/>
                  </div> 
                </div>
                    </div></div>
            </div></div>}
        </div>
        
    );
};

export default ChatAI;
